import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import Web3WalletHero from "./Web3WalletHero";
import WebWalletDevS from "./WebWalletDevS";
import WhatIsWeb3W from "./WhatIsWeb3W";
import EnhancedUserSecurity from "./EnhancedUserSecurity";
import ExperiencedTeam from "../../Exchange/Market Making Services/ExperiencedTeam";
import UserControl from "./UserControl";
import WhyChoose from "../NFT Wallet/WhyChoose";

function Web3Wallet() {
  return (
    <>
      <Header />
      <Web3WalletHero />
      <WebWalletDevS />
      <WhatIsWeb3W />
      <EnhancedUserSecurity />
      <UserControl />
      <WhyChoose />
      <Footer />
    </>
  );
}

export default Web3Wallet;
